<template>
  <div
    class="gw_table_body_row"
    @click="$emit('click')"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TableBodyRow',
  mixins: [],
  props: {
    thead: Object,
  },
  emits: ['click'],
}
</script>
